import { CardDetailsParams } from "../../typings";

export const getCardDetailsParams = (props): CardDetailsParams => {
    return {
        event: props.event,
        handlers: props.handlers,
        dict: props.dict,
        showLeagueInEventCard: props.showLeagueInEventCard,
        markets: props.markets,
        isDesktop: props.isDesktop
    }
}